import { render, staticRenderFns } from "./Advises.vue?vue&type=template&id=696571a2&"
import script from "./Advises.vue?vue&type=script&lang=js&"
export * from "./Advises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports